import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { NavLink } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { NAV_ITEMS } from '@/utils/navigation';
import { useAuth } from '@/context/AuthContext';
import { cn } from '@/lib/utils';

interface MenuSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MenuSheet: React.FC<MenuSheetProps> = ({ open, onOpenChange }) => {
  const { user, signOut } = useAuth();

  const navItems = NAV_ITEMS;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent 
        data-testid="sheet-content"
        className="w-full max-w-[300px] sm:max-w-[400px]"
      >
        <SheetDescription className="sr-only">Navigation menu</SheetDescription>
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col gap-4 mt-6">
          <nav className="flex flex-col gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => onOpenChange(false)}
                className={({ isActive }) => cn(
                  "flex items-center gap-3 px-4 py-2 rounded-md transition-colors",
                  isActive 
                    ? "bg-primary/10 text-primary"
                    : "text-muted-foreground hover:text-foreground hover:bg-accent"
                )}
              >
                <item.icon className="shrink-0 h-4 w-4 sm:h-5 sm:w-5" />
                <span className="text-sm sm:text-base">{item.label}</span>
              </NavLink>
            ))}
          </nav>
          
          <button
            onClick={() => {
              signOut();
              onOpenChange(false);
            }}
            className="flex items-center gap-3 px-4 py-2 text-destructive hover:bg-destructive/10 rounded-md transition-colors mt-auto"
          >
            <LogOut className="shrink-0 h-4 w-4 sm:h-5 sm:w-5" />
            <span>Sign Out</span>
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
